import { FC } from 'react';

import { t } from '@core/i18n';
import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { Toast, ToastProps } from '@shared/components/toast';
import { AlertRoundIcon } from '@shared/icons/alert-round';

import { styles } from './AtlasTransactionFailureToast.styles';

export interface AtlasTransactionFailureToastProps
  extends Omit<ToastProps, 'classes'>,
    WithStyles<typeof styles> {
  title: string;
  url: string;
  onClickLink: (link: string) => void;
}

const AtlasTransactionFailureToastComponent: FC<AtlasTransactionFailureToastProps> = ({
  classes,
  title,
  url,
  onClickLink,
  onClose,
}) => {
  return (
    <Toast classes={{ root: classes.root }} icon={<AlertRoundIcon classes={{ root: classes.icon }} />} title={title} onClose={onClose}>
      <div className={classes.content}>
        <span
          className={classes.link}
          onClick={() => {
            if (url) {
              onClickLink(url);
              onClose();
            }
          }}
        >
          {t('view')}
        </span>
      </div>
    </Toast>
  );
};

export const AtlasTransactionFailureToast = withStyles(styles)(AtlasTransactionFailureToastComponent);
